export class Controller {

    /** @ngInject */
    constructor(
        $state,
        $window,
        $filter,
        Alert,
        UsersResource
    ) {
		this.Alert=Alert;
		this.$state=$state;
		this.UsersResource = UsersResource;
        this.$window = $window;
        this.$filter=$filter;
	}
    
       $onInit() {
    }

    generateBackupCodes() {
        const companyId = this.companyId;
       	const  companyUserId=this.companyUser.id;
		this.isSaving = true;
		//var a = document.createElement("a");
		//document.body.appendChild(a);
		this.UsersResource.getUsersBackupOtps(companyId,companyUserId).then((response)=>{
			//var filename = this.getFileNameFromHttpResponse(response);
			//console.log(filename);
			//var fileURL = this.$window.URL.createObjectURL(response.data);
			//a.href = fileURL;
			//a.download = filename;
			//a.click();
			//setTimeout(function() { this.$window.URL.revokeObjectURL(fileURL); }, 100);
			this.generatedContent=response;
		}).finally(() => this.isSaving = false)
    }
    downloadGeneratedContent(){
		var timeOfGeneration= new Date(Number(this.generatedContent.timestamp));
		var formatedDate ='#Generated Codes: '+ this.$filter('date')(timeOfGeneration, "dd-MM-yyyy hh:mm:ss");
		var fileContent= formatedDate + "\n\n" + this.generatedContent.backupOtps.join("\n");
		
		var file = new Blob([fileContent], {
                    type : 'text/plain'
                });
                var fileURL = this.$window.URL.createObjectURL(file);
                var a = document.createElement('a');
                a.href = fileURL;
                a.target = '_blank';
                a.download = this.companyUser.saaspassUser.saaspassId +'_emergency_access_codes_company_' + this.currentCompany.companyName + '.txt';
                document.body.appendChild(a);
                a.click();
                setTimeout(function() { this.$window.URL.revokeObjectURL(fileURL); }, 100);
	}
    getFileNameFromHttpResponse(httpResponse) {
		var contentDispositionHeader = httpResponse.headers('Content-Disposition');
		var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
		return result.replace(/"/g, '');
	}
	
	cancel(){
		this.$state.go('^');
	}
    
}


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/backup-codes/backup-codes.controller.js